/*
 * @Description: 
 * @Author: lanzhisheng
 * @Date: 2023-03-01 14:09:35
 * @LastEditTime: 2023-03-01 16:41:31
 * @LastEditors: lanzhisheng
 */
import React from 'react'
import { HashRouter, Routes, Route } from 'react-router-dom'
import Home from './pages/home'
import Distribute from './pages/distribute'
import Detail from './pages/detail'
import ListCase from './pages/list'
import Customer from './pages/customer'
import AccountRegister from './pages/accountRegister'
import AccountDefer from './pages/accountDefer'
import AccountPause from './pages/accountPause'
import AccountChange from './pages/accountChange'
import SelectCustomerPage from './pages/selectCustomer'
import ApplyAccountPage from './pages/applyAccount'

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/distribute" element={<Distribute />} />
        <Route path="/detail" element={<Detail />} />
        <Route path="/list" element={<ListCase />} />
        <Route path="/customer" element={<Customer />} />
        <Route path="/accountRegister" element={<AccountRegister />} />
        <Route path="/accountDefer" element={<AccountDefer />} />
        <Route path="/accountPause" element={<AccountPause />} />
        <Route path="/accountChange" element={<AccountChange />} />
        <Route path="/selectCustomer" element={<SelectCustomerPage />} />
        <Route path="/applyAccount" element={<ApplyAccountPage />} />
      </Routes>
    </HashRouter>
  )
}
